/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Sales POCs (people classification + SME monthly targets) —
   RTK Query slice. Same transport pattern as the other growthos*ApiSlice files.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get, patchGeneric, putGeneric } from '../common/constants'
// listPeople already lives in growthosBrandsApiSlice (same PEOPLE endpoint, used by the
// Brands page's Sales POC dropdown) — reuse that hook/cache here rather than standing up a
// second, unsynchronized RTK Query cache for the same data.
export { useListPeopleQuery } from './growthosBrandsApiSlice'

const PEOPLE = apiConstants.GROWTHOS_ADMIN_PEOPLE // 'growthos-admin/people'
const SME_TARGETS = apiConstants.GROWTHOS_ADMIN_SME_TARGETS // 'growthos-admin/sme-targets'

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosPocsApiSlice = createApi({
  reducerPath: 'growthosPocsApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['SmeTarget'],
  endpoints: (b) => ({
    // team/joiningDate/managerPersonId — only present keys are updated. No invalidatesTags:
    // the list this feeds (useListPeopleQuery, re-exported above from growthosBrandsApiSlice)
    // lives in a different RTK Query cache — PocsPage calls that query's own .refetch() after
    // a successful patch instead.
    patchPerson: b.mutation({
      queryFn: ({ id, body }) => run(patchGeneric(`${PEOPLE}/${id}`, body)),
    }),
    getSmeTargets: b.query({
      queryFn: (month) => run(get(SME_TARGETS, { month })),
      providesTags: ['SmeTarget'],
    }),
    // Both targets null clears the row for (personId, month).
    setSmeTarget: b.mutation({
      queryFn: ({ personId, month, revenueTarget, shipmentsTarget }) =>
        run(putGeneric(SME_TARGETS, { personId, month, revenueTarget, shipmentsTarget })),
      invalidatesTags: ['SmeTarget'],
    }),
  }),
})

export const {
  usePatchPersonMutation,
  useGetSmeTargetsQuery,
  useSetSmeTargetMutation,
} = growthosPocsApiSlice
